import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import RoutesForAuthenticatedUsers from "./auth/RoutesForAuthenticatedUsers";
import RoutesForUnauthenticatedUsers from './auth/RoutesForUnauthenticatedUsers';

import Login from './components/views/public/Login';
import Register from './components/views/protected/registration/Register';
import Home from './components/views/protected/Home';
import PersonalProfile from './components/views/protected/PersonalProfile';
import ScoutProfile from './components/views/protected/ScoutProfile';
import ScoutCensus from './components/views/protected/ScoutCensus';
import Censuses from './components/views/leader/Censuses';
import RoutesForLeaderUsers from './auth/RoutesForLeaderUsers';
import RegisterSummary from './components/views/protected/registration/RegisterSummary';
import Migrate from "./components/views/protected/Migrate";
import ActiveScoutCensusSummary from './components/views/protected/scoutCensus/active/ActiveScoutCensusSummary';
import ReserveScoutCensusSummary from './components/views/protected/scoutCensus/reserve/ReserveScoutCensusSummary';
import VacationScoutCensusSummary from './components/views/protected/scoutCensus/vacation/VacationScoutCensusSummary';
import RoutesForUsersDuringMigration from "./auth/RoutesForUsersDuringMigration";
import RoutesForUsersDuringRegister from "./auth/RoutesForUsersDuringRegister";
import {useAuth, UserStatus} from "./auth/AuthProvider";
import RodoPage from './components/views/public/RodoPage';
import MainRouters from "./auth/MainRouters";
import AuthorsPage from "./components/views/public/AuthorsPage";
import Info from "./components/views/public/Info";
const App: React.FC = () => {
  const { isLeader, userStatus } = useAuth();
  console.log(userStatus);
  return (
      <Router>
        <Routes>

          {/* During register */}
          {userStatus === UserStatus.ToRegister && (
              <Route element={<RoutesForUsersDuringRegister />}>
                  <Route path="/" element={<Register />} />
                  <Route path="/register-summary" element={<RegisterSummary />} />
                  {/*<Route path="/migrate" element={<Migrate />} />*/}
              </Route>
          )}

          {/* During migration */}
          {userStatus === UserStatus.ToRegister && (
              <Route element={<RoutesForUsersDuringMigration />}>
                  <Route path="/" element={<Migrate />} />
              </Route>
          )}
            
          {/* Instructor */}
          {userStatus === UserStatus.LoggedIn && (
              <Route element={<RoutesForAuthenticatedUsers />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/personal-profile" element={<PersonalProfile />} />
                  <Route path="/scout-profile" element={<ScoutProfile />} />
                  <Route path="/scout-census" element={<ScoutCensus />} />
                  <Route path="/scout-census/summary/active" element={<ActiveScoutCensusSummary />} />
                  <Route path="/scout-census/summary/reserve" element={<ReserveScoutCensusSummary />} />
                  <Route path="/scout-census/summary/vacation" element={<VacationScoutCensusSummary />} />

                  {/* Leader */}
                  <Route element={<RoutesForLeaderUsers />}>
                      <Route path='/censuses/*' element={<Censuses />} />
                  </Route>
                  {isLeader && (
                      <Route element={<RoutesForLeaderUsers />}>
                          <Route path='/censuses/*' element={<Censuses />} />
                      </Route>
                  )}
              </Route>
          )}

          {/* Unauthenticated */}
          {(userStatus === UserStatus.None || userStatus === null) && (
              <Route element={<RoutesForUnauthenticatedUsers />}>
                  <Route path="/" element={<Login />} />
                  <Route path="/" element={<Login />} />
                  <Route path="/login" element={<Login />} />
              </Route>
          )}
          
          {/* Redirect to /home for any undefined routes */}
            <Route element={<MainRouters />}>
                <Route path="/" element={<Home />} />
                <Route path="/authors" element={<AuthorsPage />} />
                <Route path="/rodo" element={<RodoPage />} />
                <Route path="/info" element={<Info />} />
            </Route>
          <Route path="*" element={<Navigate to="/" />} />

        </Routes>
      </Router>
  );
};

export default App;
